import { render, staticRenderFns } from "./datedown.vue?vue&type=template&id=cd285986&scoped=true"
import script from "./datedown.vue?vue&type=script&lang=js"
export * from "./datedown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd285986",
  null
  
)

export default component.exports